import { defineStore } from 'pinia';
import { API } from '@/services';
import { GET_WORKSPACES_QUERY } from '@/services/workspace/queries/workspace/index.js';
import { useUserStore } from '@/stores/user.store.js';

export const useSettingsStore = defineStore({
  id: 'settings',
  state: () => ({
    // activeAccountTeamMembers: [],
    activeWorkspace: localStorage.getItem('_pup_active_settings_workspace')
      ? JSON.parse(localStorage.getItem('_pup_active_settings_workspace'))
      : null,
    activeAccount: localStorage.getItem('_pup_active_settings_account') ? JSON.parse(localStorage.getItem('_pup_active_settings_account')) : null,
    workspaces: [],
    accounts: [],
    isLoadingAccounts: false,
    isLoadingWorkspaces: false
  }),
  actions: {
    setAccounts(accounts) {
      this.accounts = accounts;
    },

    setActiveAccount(account) {
      this.activeAccount = account;
      localStorage.setItem('_pup_active_settings_account', JSON.stringify(account));
      if (localStorage.getItem('_pup_active_settings_workspace')) {
        this.activeWorkspace = null;
        localStorage.removeItem('_pup_active_settings_workspace');
      }
    },

    setWorkspaces(workspaces) {
      this.workspaces = workspaces;
    },

    async setActiveWorkspace(workspace) {
      this.activeWorkspace = workspace;
      localStorage.setItem('_pup_active_settings_workspace', JSON.stringify(workspace));
    },

    async getSettingsPermissions() {
      try {
        const payload = {
          account_id: Number(this.activeAccount?.id),
          workspace_id: Number(this.activeWorkspace?.id)
        };
        await useUserStore().getCurrentUserPermissions(payload);
      } catch (error) {
        console.log(error);
      }
    },

    async getWorkspaces() {
      try {
        this.isLoadingWorkspaces = true;
        const payload = {
          admin: true,
          archived: false,
          account_id: Number(this.activeAccount.id)
        };
        const res = await API.sendQuery('/graphql/workspace', GET_WORKSPACES_QUERY, payload);
        if (res.data.data.workspaces) {
          this.setWorkspaces(res.data.data.workspaces);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingWorkspaces = false;
      }
    }
  }
});
